/* unplugin-vue-components disabled */import { render } from "./article-card.vue?vue&type=template&id=631ae143&scoped=true"
import script from "./article-card.vue?vue&type=script&lang=js"
export * from "./article-card.vue?vue&type=script&lang=js"

import "./article-card.vue?vue&type=style&index=0&id=631ae143&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631ae143"],['__file',"src/components/cards/article-card.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "631ae143"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('631ae143', __exports__)) {
    api.reload('631ae143', __exports__)
  }
  
  module.hot.accept("./article-card.vue?vue&type=template&id=631ae143&scoped=true", () => {
    api.rerender('631ae143', render)
  })

}


export default __exports__